import BoxDetail from "./boxDetails.container";

export default BoxDetail;
